module.exports = __webpack_public_path__ + "static/media/checkmark.88238c9f.svg";